import React from 'react';
import {useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

import {Loading} from '../../components';
import {tierText} from '../../function';
import SummonerDict from "../common/SummonerDict";
import IngameEmblem from "./Ingame/IngameEmblem";
import styled from "styled-components";
import SummonerTags from "./SummonerTags";
import InfluInfo from "./Profile/InfluInfo";


const DictWrapper = styled.div`
  min-height: 15px;
  min-width: 60px;
`;

const TagWrapper = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  align-items: flex-end;
  margin-bottom: 2px;
  flex-direction: ${props => {
    let direction = 'row';
    if (props.side === 'red') direction = 'row-reverse';
    return direction;
  }};
`;
const IngameSummoner = ({gameInfo, summoner, lane, side, ranks}) => {


    const {t} = useTranslation();
    const region = useSelector((state) => state.region.result);
    const rankQueue = 'ranked_solo_5x5';


    console.log(side);
    return (
        <div>
            <div className="summoner_info">
                {(summoner?.season_tier_info_dict?.ranked_solo_5x5 !== undefined && summoner?.season_tier_info_dict?.ranked_solo_5x5 != {}) ? (
                    <>
                        <TagWrapper side={side}>
                            <DictWrapper>
                                <SummonerDict
                                    onlyLatest={true}
                                    reverse={side === 'red'}
                                    dict={summoner.summoner_basic_info_dict?.previous_season_tier_list}
                                />
                            </DictWrapper>
                            <SummonerTags
                                ranks={ranks}
                                data={gameInfo}
                            />
                        </TagWrapper>
                        <IngameEmblem
                            summoner={summoner}
                            gameInfo={gameInfo}
                            lane={lane}
                            rankQueue={rankQueue}
                        />
                        <div className="profile_data">
                            {summoner.season_tier_info_dict[rankQueue]?.hasOwnProperty('tier') ? (
                                <div className="texts">

                                    {summoner?.summoner_basic_info_dict?.pro_streamer_info_dict?.status !== '-' &&
                                        <dl className="t2">
                                            <InfluInfo
                                                maxWidthText={80}
                                                direction={side === 'blue' ? "row" : "row-reverse"}
                                                textColor={'#000'}
                                                showLinks={false}
                                                influData={summoner.summoner_basic_info_dict.pro_streamer_info_dict}
                                            />
                                        </dl>}
                                    {/*                {summoner.pro_streamer_info.team !== '-' && (*/}
                                    {/*                    <span className="pro">*/}
                                    {/*{summoner.pro_streamer_info.team.length > 14*/}
                                    {/*    ? summoner.pro_streamer_info.team*/}
                                    {/*    : summoner.pro_streamer_info.alias}{' '}*/}
                                    {/*                        {summoner.pro_streamer_info.name}</span>*/}
                                    {/*                )}*/}

                                    <Link
                                        replace
                                        to={`/summoner/${region}/${summoner.summoner_name}`}
                                        target="_blank"
                                        className="common_search"
                                    >
                                        {summoner.summoner_name}
                                    </Link>
                                    <dl className="t1">
                                        <dt>
                                            {tierText(
                                                summoner.season_tier_info_dict[rankQueue].tier,
                                                summoner.season_tier_info_dict[rankQueue].division
                                            )}
                                            /
                                        </dt>
                                        <dd>{summoner.season_tier_info_dict[rankQueue].league_points.toLocaleString()} LP</dd>
                                    </dl>
                                    <dl className="t2">
                                        {Object.values(summoner.season_tier_info_dict[rankQueue]).length !== 0 ? (
                                            <dt>
                                                <span>
                                                    {isNaN(
                                                        summoner.season_tier_info_dict[rankQueue].wins /
                                                        (summoner.season_tier_info_dict[rankQueue].wins +
                                                            summoner.season_tier_info_dict[rankQueue].losses)
                                                    )
                                                        ? 0 : (
                                                            (summoner.season_tier_info_dict[rankQueue].wins /
                                                                (summoner.season_tier_info_dict[rankQueue].wins +
                                                                    summoner.season_tier_info_dict[rankQueue].losses)) * 100).toFixed(1)}
                                                </span>
                                                %
                                            </dt>
                                        ) : (
                                            <dt>
                                                <span>-</span>%
                                            </dt>
                                        )}
                                        {Object.values(summoner.season_tier_info_dict[rankQueue]).length !== 0 ? (
                                            <dd>
                      <span>
                        {(
                            summoner.season_tier_info_dict[rankQueue].wins + summoner.season_tier_info_dict[rankQueue].losses
                        ).toLocaleString()}
                      </span>
                                                {t('summoner.games')}
                                            </dd>
                                        ) : (
                                            <dd>
                                                <span>-</span>
                                                {t('summoner.games')}
                                            </dd>
                                        )}
                                    </dl>
                                    {summoner.season_tier_info_dict[rankQueue]?.mini_series_dict?.progress && (
                                        <div className="promos">
                                            {summoner.season_tier_info_dict[rankQueue]?.mini_series_dict.progress.split('').map((item, index) => (
                                                <span key={index} className={item}>{item}</span>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ) : (

                                <>
                                    <div className="texts">
                                        <div style={{
                                            display: 'inline-block'
                                        }}>
                                            {summoner?.summoner_basic_info_dict.pro_streamer_info_dict?.status !== '-' &&
                                                <dl className="t2">
                                                    <InfluInfo
                                                        maxWidthText={80}
                                                        direction={side === 'blue' ? "row" : "row-reverse"}
                                                        textColor={'#000'}
                                                        showLinks={false}
                                                        influData={summoner.summoner_basic_info_dict.pro_streamer_info_dict}
                                                    />
                                                </dl>}
                                            <Link
                                                replace
                                                to={`/summoner/${region}/${summoner.summoner_basic_info_dict.summoner_name}`}
                                                target="_blank"
                                                className="common_search"
                                            >
                                                {summoner.summoner_basic_info_dict.summoner_name}
                                            </Link>
                                        </div>
                                        <div>{t('summoner.unranked')}</div>
                                    </div>
                                </>

                            )}
                        </div>
                    </>
                ) : (
                    <Loading/>
                )}
            </div>
        </div>
    );
};

export default React.memo(IngameSummoner);
